<template>
  <div class="body">
    <div class="d-flex text-center justify-center mb-5">
      <v-sheet class="mt-5 pb-5" width="920px" >
        <h2 class="pt-3">Contact Us</h2>
        <v-layout justify-center>
          <div class="col-7 ma-0 pa-0 pt-10">           
            <br/>
            <p>Need to contact us?<br/>Drop us an email at <a href="mailto:support@diminished-studios.com" target="_blank">support@diminished-studios.com</a></p>
            <p>For faster support, visit our <a href="https://discord.gg/znpKqsb" target="_blank">Discord</a></p>
            
            <h2 class="pt-10">Cheers,</h2>
            <h3 class="pb-1">Diminished Studios Team</h3>
          </div>
          
        </v-layout>

      </v-sheet>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  metaInfo: {
    title: 'Diminished Studios - Contact Us',
    titleTemplate: '%s',
    htmlAttrs: {
      lang: 'en-US'
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: "Need support? You can contact us here" },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { property: 'og:title', content: 'Diminished Studios - Contact Us' },
      { property: 'og:image', content:'https://i.imgur.com/lVLowgo.png'}
    ]
  },
  data: () => ({

  }),
  methods: {
    openInNewTab(url) {
      window.open(url, '_blank', 'noreferrer');
    },
  },
}
</script>

<style>
.body{
  min-height: 72vh;
}
.v-image {
  .v-image__image {
    transition: all 0.4s;
  }

  &.zoom {
    .v-image__image {
      transform: scale(1.1);
    }
  }
}

.text {
  font-size: 13px;
  text-align: left;
}

.homepagecard {
  font-size: 16px;
  font-weight: bolder;
}

.homepagecarddesc {
  font-size: 14px;
}

.video {
  background-color: #181818;
  width: 100%;
}</style>
